import request from '@/utils/request';


let server = {
  signIn: '/authorizations', // 登录
  signInCode: '/verification_codes', // 手机登录短信验证码
  signInDynamic: '/phone_store', // 手机动态登录
  refreshToken: '/authorizations/current', // 刷新token
  deleteToken: '/authorizations/current', // 删除token
  setPass: '/set_pass', // 修改密码
  verificationReset: '/verification_reset', // 发送忘记密码验证码
  forgetPass: '/forget_pass', // 忘记密码
};



//  用户登录
export function signIn(params) {
	return request({
    	url: server.signIn,
	    method: 'post',
	    data:params
  	})
}

//  手机登录短信验证码
export function signInCode(params) {
	return request({
    	url: server.signInCode,
	    method: 'post',
	    data:params
  	})
}

//  手机动态登录
export function signInDynamic(params) {
	return request({
    	url: server.signInDynamic,
	    method: 'post',
	    data:params
  	})
}


//  刷新token
export function refreshToken() {
  return request({
    url: server.refreshToken,
    method: 'put'
  })
}

//  删除token
export function deleteToken() {
  return request({
    url: server.deleteToken,
    method: 'delete'
  })
}


//  修改密码
export function setPass(params) {
  return request({
    url: server.setPass,
    method: 'patch',
    data:params
  })
}


//  发送忘记密码验证码
export function verificationReset(params) {
  return request({
    url: server.verificationReset,
    method: 'post',
    data:params
  })
}


//  发送忘记密码验证码
export function forgetPass(params) {
  return request({
    url: server.forgetPass,
    method: 'patch',
    data:params
  })
}







// WEBPACK FOOTER //
// ./src/api/signIn.js